import React from "react";
import {Button} from 'reactstrap';
import * as ReactGA from "react-ga";

export default class NotFound extends React.Component {
    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
    return (
      <>
        <div className="not-found">
          <h1>404</h1>
          <p>Not Found</p>
          <Button color="none">Kembali Ke Home</Button>
        </div>
      </>
    );
  }
}
